/*
 * @Author: Zhouqi
 * @Date: 2025-11-08 15:27:12
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-08 17:01:18
 */

/**
 * 通用上传配置常量
 */
export const MAX_COUNT_DEFAULT = 1;

/**
 * 支持的文件类型
 */
export const FILE_TYPES = {
  AUDIO: ['.mp3', '.wav', '.m4a', '.mp4', '.mov'],
  IMAGE: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'],
  VIDEO: ['.mp4', '.mov', '.avi', '.mkv', '.webm'],
} as const;

/**
 * 文件处理状态枚举
 */
export enum FILE_STATUS {
  /** 等待上传 */
  PENDING = 'pending',
  /** 上传中 */
  UPLOADING = 'uploading',
  /** 上传成功 */
  SUCCESS = 'done',
  /** 上传失败 */
  ERROR = 'error',
  /** 已删除 */
  REMOVED = 'removed',
}
